module.exports = __webpack_public_path__ + "static/media/usd.3f768761.png";